import { useI18n } from '../i18n';
import styles from './Stats.module.css';

/**
 * Three figures between two hairlines. The numbers are Gloock, because in this
 * brand a figure is display type rather than data.
 */
export function Stats() {
  const { t } = useI18n();

  return (
    <section className={styles.section}>
      {t.stats.map((stat) => (
        <div key={stat.label} className={styles.stat}>
          <span className={styles.value}>{stat.value}</span>
          <span className={styles.label}>{stat.label}</span>
        </div>
      ))}
    </section>
  );
}
